export default __webpack_public_path__ + "static/media/wolchapter2.ba39e2cb.png";